import { Component, OnInit, Input, Output } from '@angular/core';

// ------------------------------------------------------
@Component({
  selector: 'smart-confirm',
  template: require('./smart-confirm.component.pug'),
  styles: [require('./smart-confirm.component.css').toString()],
})
export class SmartConfirmComponent implements OnInit {
  @Input('enabled')
  enabled: boolean;

  @Input('title')
  title: string = 'Confirm';
  @Input('confirmTitle')
  confirmTitle: string = 'Confirm';
  @Input()
  icon: string = 'far fa-trash-alt';
  @Input('data')
  data: any;
  @Input('color')
  color: boolean = true;
  @Input('disabled')
  disabled: boolean = false;
  @Input('extraclass')
  extraclass: string = '';

  @Input('confirmed')
  confirmed: onSmartDeleteCallback;

  hasError: boolean = false;
  loading: boolean = false;
  errorText: string = '';

  confirm: boolean = false;

  // -------------------------------------------------------------------
  constructor() {}

  // -------------------------------------------------------------------
  ngOnInit() {
    if (!this.title) {
      this.title = 'Unknown';
    }
  }

  // -------------------------------------------------------------------
  buttonClass() {
    let newClass = {};

    newClass[this.extraclass] = true;

    newClass['btn-error'] = this.hasError;

    return newClass;
  }

  // -------------------------------------------------------------------
  onSuccess() {
    this.loading = false;
    this.confirm = false;
  }

  // -------------------------------------------------------------------
  onFailure(errorText: string) {
    console.warn('failure');
    this.hasError = true;
    this.loading = false;
    this.errorText = errorText;
    this.confirm = false;
  }

  // -------------------------------------------------------------------
  deleteSomething(e) {
    //console.log({ e });
    if (this.loading) {
      return;
    }

    if (this.confirm == false) {
      this.confirm = true;
      return;
    }

    this.loading = true;
    this.hasError = false;
    this.errorText = null;
    this.confirmed(
      this.data,
      this.onSuccess.bind(this),
      this.onFailure.bind(this),
    );
  }
}
